var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card my-3"},[_c('div',{staticClass:"card-header"},[_c('span',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('canvas',{attrs:{"id":_vm.chartid}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42dd9e55","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ResultCard.vue
// module id = null
// module chunks = 